// https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/
import { useState, useEffect } from "react";

export const useViewport = () => {
    const [browserWidth, setWidth] = useState(window.innerWidth);
    const [browserHeight, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleWindowResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return { browserWidth, browserHeight };
};

// TODO: finish this tutorial when we are using 1 App.js for the whole site
